/* YT Tech Details – Tabs, wheel-size + flip-chip toggles, geometry table, row-hover silhouette */
(function () {
  var tableFields = [
    { key: 'toptube',        label: 'Top Tube',        unit: 'mm' },
    { key: 'reach',          label: 'Reach',           unit: 'mm' },
    { key: 'stack',          label: 'Stack',           unit: 'mm' },
    { key: 'seattube',       label: 'Seat Tube',       unit: 'mm' },
    { key: 'chainstay',      label: 'Chainstay',       unit: 'mm' },
    { key: 'headtube_angle', label: 'Head Tube Angle', unit: '°', decimal: 1 },
    { key: 'seattube_angle', label: 'Seat Tube Angle', unit: '°', decimal: 1 },
    { key: 'bb_drop',        label: 'BB Drop',         unit: 'mm' },
    { key: 'wheelbase',      label: 'Wheelbase',       unit: 'mm' },
    { key: 'headtube',       label: 'Head Tube',       unit: 'mm' },
    { key: 'bb_height',      label: 'BB Height',       unit: 'mm' },
    { key: 'standover',      label: 'Standover',       unit: 'mm' }
  ];

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function init(container) {
    var dataEl = container.querySelector('[data-geo-json]');
    if (!dataEl) return;
    var geoData;
    try { geoData = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var state = {
      wheel: geoData.defaultWheel || (geoData.wheelSizes && geoData.wheelSizes[0]) || 'default',
      chip: 'low',
      sizeIdx: 0
    };

    function getBucket() {
      return (geoData.datasets && geoData.datasets[state.wheel]) || null;
    }

    function getData() {
      var b = getBucket();
      if (!b) return {};
      return b[state.chip] || b.low;
    }

    function getSizes() {
      var b = getBucket();
      return (b && b.sizes) || [];
    }

    function hasData(key) {
      var d = getData();
      return d[key] && d[key].length > 0 && d[key].some(function (v) { return v != null && v !== '' && v !== 0; });
    }

    function activeFields() {
      return tableFields.filter(function (f) { return hasData(f.key); });
    }

    function renderTable() {
      var tableEl = container.querySelector('[data-table]');
      if (!tableEl) return;
      var data = getData();
      var sizes = getSizes();
      var fields = activeFields();

      /* Render size tabs above the table (mobile-only visibility via CSS).
         Injected into .yt-td__table-col before the table-wrap. */
      var tableCol = tableEl.closest('.yt-td__table-col');
      var oldTabs = tableCol && tableCol.querySelector('[data-size-tabs]');
      if (oldTabs) oldTabs.remove();
      if (tableCol && sizes.length > 0) {
        var tabsHtml = '<div class="yt-td__size-tabs" data-size-tabs>';
        sizes.forEach(function (s, i) {
          tabsHtml +=
            '<button type="button" class="yt-td__size-tab' +
            (i === state.sizeIdx ? ' is-active' : '') +
            '" data-size-tab="' + i + '">' +
            esc(String(s).trim()) +
            '</button>';
        });
        tabsHtml += '</div>';
        tableCol.insertAdjacentHTML('afterbegin', tabsHtml);
      }

      var html = '<thead><tr><th data-col="label"></th>';
      sizes.forEach(function (s, i) {
        html += '<th data-col="' + i + '">' + esc(String(s).trim()) + '</th>';
      });
      html += '</tr></thead><tbody>';

      fields.forEach(function (f) {
        var vals = data[f.key];
        if (!vals || !vals.length) return;
        html += '<tr data-metric-key="' + f.key + '"><td data-col="label">' + esc(f.label) + '</td>';
        vals.forEach(function (v, i) {
          if (v == null || v === '') {
            html += '<td data-col="' + i + '">—</td>';
            return;
          }
          var display = f.decimal ? Number(v).toFixed(f.decimal) : Math.round(Number(v));
          html += '<td data-col="' + i + '"><span class="yt-td__table-val">' + display + '</span><span class="yt-td__table-unit">' + f.unit + '</span></td>';
        });
        html += '</tr>';
      });
      html += '</tbody>';
      tableEl.innerHTML = html;
      tableEl.dataset.activeSize = String(state.sizeIdx || 0);
    }

    function setSilhouetteLine(metricKey) {
      var lines = container.querySelectorAll('[data-line-metric]');
      lines.forEach(function (el) {
        el.classList.toggle('is-active', metricKey != null && el.dataset.lineMetric === metricKey);
      });
    }

    function syncChipVisibility() {
      var group = container.querySelector('[data-chip-group]');
      if (!group) return;
      var bucket = getBucket();
      var hasFlip = !!(bucket && bucket.hasFlipChip);
      group.hidden = !hasFlip;
      if (!hasFlip) {
        state.chip = 'low';
        var btns = group.querySelectorAll('[data-chip]');
        btns.forEach(function (b) {
          var active = b.dataset.chip === 'low';
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', String(active));
        });
      }
    }

    function wireHover() {
      var tbody = container.querySelector('[data-table] tbody');
      if (!tbody) return;

      tbody.addEventListener('mouseover', function (e) {
        var row = e.target.closest('tr[data-metric-key]');
        if (!row || !tbody.contains(row)) return;
        tbody.querySelectorAll('tr.is-hovered').forEach(function (r) { r.classList.remove('is-hovered'); });
        row.classList.add('is-hovered');
        setSilhouetteLine(row.dataset.metricKey);
      });

      tbody.addEventListener('mouseleave', function () {
        tbody.querySelectorAll('tr.is-hovered').forEach(function (r) { r.classList.remove('is-hovered'); });
        setSilhouetteLine(null);
      });
    }

    function wireTabs() {
      var tabs = container.querySelectorAll('[data-tab]');
      var panels = container.querySelectorAll('[data-panel]');

      function activate(tab) {
        if (tab.classList.contains('is-disabled')) return;
        var target = tab.dataset.tab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
          if (active) {
            t.removeAttribute('tabindex');
          } else if (!t.classList.contains('is-disabled')) {
            t.setAttribute('tabindex', '-1');
          }
        });
        panels.forEach(function (p) {
          var active = p.dataset.panel === target;
          p.classList.toggle('is-active', active);
          p.hidden = !active;
        });
      }

      /* Roving-tabindex + arrow-key navigation per WAI-ARIA Tabs Pattern.
         Skips disabled tabs; Home/End jump to first/last enabled tab. */
      function focusableTabs() {
        return Array.prototype.filter.call(tabs, function (t) {
          return !t.classList.contains('is-disabled');
        });
      }

      function moveFocus(currentTab, dir) {
        var enabled = focusableTabs();
        if (!enabled.length) return;
        var idx = enabled.indexOf(currentTab);
        var next;
        if (dir === 'home') next = enabled[0];
        else if (dir === 'end') next = enabled[enabled.length - 1];
        else if (dir === 'prev') next = enabled[(idx - 1 + enabled.length) % enabled.length];
        else if (dir === 'next') next = enabled[(idx + 1) % enabled.length];
        if (next) {
          activate(next);
          next.focus();
        }
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab); });
        tab.addEventListener('keydown', function (e) {
          switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              e.preventDefault(); moveFocus(tab, 'next'); break;
            case 'ArrowLeft':
            case 'ArrowUp':
              e.preventDefault(); moveFocus(tab, 'prev'); break;
            case 'Home':
              e.preventDefault(); moveFocus(tab, 'home'); break;
            case 'End':
              e.preventDefault(); moveFocus(tab, 'end'); break;
          }
        });
      });
    }

    function wireChip() {
      var chipBtns = container.querySelectorAll('[data-chip]');
      if (!chipBtns.length) return;
      chipBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.chip = btn.dataset.chip;
          chipBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
          });
          renderTable();
          wireHover();
        });
      });
    }

    function wireSizeTabs() {
      /* Event delegation on the container — tabs are re-rendered per table redraw */
      container.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-size-tab]');
        if (!tab) return;
        var idx = parseInt(tab.dataset.sizeTab, 10) || 0;
        state.sizeIdx = idx;
        var tableEl = container.querySelector('[data-table]');
        if (tableEl) tableEl.dataset.activeSize = String(idx);
        container.querySelectorAll('[data-size-tab]').forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.dataset.sizeTab, 10) === idx);
        });
      });
    }

    function wireWheel() {
      var wheelBtns = container.querySelectorAll('[data-wheel]');
      if (!wheelBtns.length) return;
      wheelBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.wheel = btn.dataset.wheel;
          state.sizeIdx = 0;
          wheelBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', String(active));
          });
          syncChipVisibility();
          renderTable();
          wireHover();
        });
      });
    }

    syncChipVisibility();
    renderTable();
    wireHover();
    wireTabs();
    wireChip();
    wireWheel();
    wireSizeTabs();
  }

  function boot() {
    document.querySelectorAll('[data-tech-details]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('[data-tech-details]');
    if (container) init(container);
  });
})();
